module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-textarea",
    class: _vm.wrapClass
  }, [(!_vm.isVertical && (_vm.hasLabel || _vm.icon.length > 0)) ? _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v(_vm._s(_vm.label))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fg-line"
  }, [_c('div', {
    staticClass: "guidance-editor"
  }, [_c('div', {
    staticClass: "toolbar",
    attrs: {
      "disabled": !_vm.isEnabled
    }
  }, [_vm._t("toolbar")], 2), _vm._v(" "), _c('div', {
    staticClass: "editarea",
    style: ({
      height: _vm.controlHeight
    })
  }, [_c('textarea', {
    staticClass: "codable",
    attrs: {
      "placeholder": _vm.placeholder,
      "disabled": !_vm.isEnabled
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      },
      "focus": _vm._p_focus,
      "blur": _vm._p_blur
    }
  })])]), _vm._v(" "), (_vm.isVertical) ? _c('label', {
    staticClass: "fg-label",
    staticStyle: {
      "margin-top": "-22px"
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12daed38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/textarea.vue
// module id = 545
// module chunks = 23